import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/icon/up-right-from-square.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "サイト管理")
], -1)
const _hoisted_3 = { class: "d-flex justify-content-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "画像の推奨サイズ：横幅 100px × 高さ 100px", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" （公開URL： ")
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "external",
  alt: "新規ウインドウで開く",
  title: "新規ウインドウで開く"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("） ")
const _hoisted_12 = { class: "d-flex justify-content-center mt-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success mx-2 mb-2",
  type: "submit"
}, "更新", -1)
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 以下のURLにアクセスすると、サイトプレビューが閲覧できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" このURLは2週間有効です。このURLを知っている人は誰でもアクセスできます。 ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("リンクをコピー")
const _hoisted_18 = { class: "text-break border p-1" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 公開処理を行うと、インターネット上で誰でも見られる状態になります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 公開中のコンテンツを更新する場合は、再度公開ボタンを押してください。 ")
], -1)
const _hoisted_22 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_23 = { class: "col-sm-10" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["disabled"]

import { computed, inject, ref, unref } from "vue"
import WysiwygEditor from "@/components/ui/WysiwygEditor.vue"
import InputImage from "@/components/ui/InputImage.vue"
import FormGroup from "@/components/ui/FormGroup.vue"
import InputText from "@/components/ui/InputText.vue"
import ModalWindow from "@/components/ModalWindow.vue"
import IconCopy from '@/components/ui/IconCopy.vue'
import { injectKey, Nicotto, ConciergeSiteSetting } from '@/plugins/nicotto'
import { useMessenger, message } from '@/plugins/message'
import { useStore } from '@/store'
import { useValidateForm } from "@/components/ui/validator";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const messenger = useMessenger()
const store = useStore()
const nicotto = inject(injectKey) as Nicotto
const settings = ref<ConciergeSiteSetting>({ name:'', publishMode:'private' })
const previewUrl = ref<string>()
const showPreview = ref(false)
const publishError = ref(false)
const publishErrorMessage = ref<string>('concierge.setting.updatePublishModeFailed')

//初期値(settings.valueとの比較＋データの保存に使用)
const defaultValue = ref<ConciergeSiteSetting>({ name:'', publishMode:'private' })

//公開URL取得用
const municipality = store.getters.isAdmin
  ? store.state.municipality
  : store.state.user?.municipality

const naviPublicBaseUrl = process.env.VUE_APP_CONCIERGE_NAVI_PUBLIC_BASE_URL

// サイト公開設定のラベル/ボタン表示テキスト
const publishModeLabel = {
  private: {
    label : '非公開',
    buttonLabel : '非公開'
  },
  publish: {
    label : '公開',
    buttonLabel : '公開'
  }
}

let iconUrl: string // アイコン画像の初期値保持用
let iconImage: File|null = null // アップロードした画像ファイル

// サイト公開設定の初期データ取得
nicotto.concierge.getSiteSetting()
  .then(data => {
    defaultValue.value = JSON.parse(JSON.stringify(data))
    settings.value = JSON.parse(JSON.stringify(data))
    iconUrl = data.iconUrl || ''
  })

const onChangeImage = (file: File|null) => {
  iconImage = file
  if (file == null) {
    // リセット時は初期値に戻す
    settings.value.iconUrl = iconUrl
  }
}

// モーダル表示時のフラグ
const edit_display = ref(false)

// モーダル表示時に値を初期化する
const setModalData = () => {
  publishError.value = false
  publishErrorMessage.value = 'concierge.setting.updatePublishModeFailed'
  edit_display.value = !edit_display.value
  defaultValue.value.publishMode = settings.value.publishMode
}

const form = ref<HTMLFormElement|null>(null)

const save = async() => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  try {
    await nicotto.concierge.updateSiteSetting(settings.value, iconImage)
    messenger.set('concierge.setting.updateSucceeded')
    defaultValue.value = {...settings.value}
    previewUrl.value = ''
   } catch (err) {
    messenger.set('concierge.setting.updateFailed')
  }
}

// 編集入力差分を比較
const editDiff = computed(() => {
  for (const [key, val] of Object.entries(settings.value)) {
    //  公開設定の選択肢を変更して「閉じる/×」を押した時、settings.value.publishModeの値が変更されたままになってしまうため比較対象外
    if (typeof key == "string" && typeof val == "string" && key != "publishMode") {
      if (val != defaultValue.value[key as keyof ConciergeSiteSetting]) {
        messenger.set('concierge.setting.modified')
        return true
      }
    }
  }
  return false
})

// サイト公開設定モーダルの公開/非公開ボタンクリック時の処理
const publishModeUpdate = async() => {
  try {
    store.commit("startLoading")
    publishError.value = false
    publishErrorMessage.value = 'concierge.setting.updatePublishModeFailed'
    await nicotto.concierge.publishConcierge(defaultValue.value.publishMode)
    settings.value.publishMode = defaultValue.value.publishMode
    edit_display.value = false // サイト公開のモーダルを閉じる
    store.commit("finishLoading")
    messenger.set('concierge.setting.updatePublishModeSucceeded')
  } catch (err:any) {
    publishError.value = true

    for (let i = 0; i < err.errors.length; i++) {
      if (err.errors[i].message.indexOf('process not found.') !== -1 ) {
        publishErrorMessage.value = 'concierge.preview.publishFailedByProcess'
      } else if (err.errors[i].message.indexOf('contact not found.') !== -1 ) {
        publishErrorMessage.value = 'concierge.preview.publishFailedByContact'
      } else if (err.errors[i].message.indexOf('data not found.') !== -1 ) {
        publishErrorMessage.value = 'concierge.setting.updatePublishModeFailedByNoData'
      } else {
        publishErrorMessage.value = 'concierge.setting.updatePublishModeFailed'
      }
    }
    store.commit("finishLoading")
  }
}

const preview = async() => {
  // プレビューデータ生成(変更がなければ同じデータのはずなので初回のみ)
  if (!previewUrl.value) {
    try {
      store.commit("startLoading")
      await nicotto.concierge.publishConcierge('preview')
    } catch (err:any) {
      for (let i = 0; i < err.errors.length; i++) {
        if (err.errors[i].message.indexOf('process not found.') !== -1 ) {
          messenger.set('concierge.preview.publishFailedByProcess')
        } else if (err.errors[i].message.indexOf('contact not found.') !== -1 ) {
          messenger.set('concierge.preview.publishFailedByContact')
        } else {
          messenger.set('concierge.preview.publishFailed')
        }
        store.commit("finishLoading")
        return
      }
      store.commit("finishLoading")
      return
    }
  }

  // プレビューURL発行
  const municipality = store.getters.isAdmin
    ? store.state.municipality
    : store.state.user?.municipality
  try {
    previewUrl.value = await nicotto.concierge.getPreviewUrl(municipality?.path as string)
    store.commit("finishLoading")
  } catch (err) {
    messenger.set('concierge.preview.generateUrlFailed')
    store.commit("finishLoading")
    return
  }

  // プレビューダイアログ表示
  showPreview.value = true
}
const copyPreviewLink = async() => {
  try {
    if (!previewUrl.value) {
      throw new Error("Empty preview link");
    }
    await navigator.clipboard.writeText(previewUrl.value)
  } catch (err) {
    alert(message('concierge.setting.copyPreviewUrlFailed'))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary mx-2",
        onClick: preview
      }, "サイトプレビュー"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary mx-2",
        onClick: setModalData,
        disabled: _unref(editDiff)
      }, "サイト公開", 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"]),
        ref_key: "form",
        ref: form,
        class: "formTable",
        novalidate: ""
      }, [
        _createVNode(FormGroup, {
          label: "サイトタイトル",
          required: true,
          "label-for": "name"
        }, {
          default: _withCtx(() => [
            _createVNode(InputText, {
              label: "サイトタイトル",
              required: true,
              id: "name",
              modelValue: settings.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "説明文",
          "label-for": "description"
        }, {
          default: _withCtx(() => [
            _createVNode(WysiwygEditor, {
              modelValue: settings.value.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "問い合わせ先",
          "label-for": "contact"
        }, {
          default: _withCtx(() => [
            _createVNode(WysiwygEditor, {
              modelValue: settings.value.contact,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.contact) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "ロゴ設定",
          "label-for": "logo",
          required: true
        }, {
          default: _withCtx(() => [
            _createVNode(InputImage, {
              id: "logo",
              modelValue: settings.value.iconUrl,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.iconUrl) = $event)),
              onChange: onChangeImage,
              required: !settings.value.iconPath
            }, null, 8, ["modelValue", "required"]),
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "公開状態",
          "label-for": "open"
        }, {
          default: _withCtx(() => [
            (settings.value.publishMode)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(publishModeLabel[settings.value.publishMode].label) + " ", 1),
                  (_unref(municipality)?.status() === 'enabled')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_8,
                        _createElementVNode("a", {
                          href: _unref(naviPublicBaseUrl) + '/' + _unref(municipality).path + '/index.html',
                          target: "_blank"
                        }, [
                          _createTextVNode(_toDisplayString(_unref(naviPublicBaseUrl) +'/'+ _unref(municipality).path + '/index.html') + " ", 1),
                          _hoisted_10
                        ], 8, _hoisted_9),
                        _hoisted_11
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "btn btn-secondary mx-2 mb-2",
            role: "button"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _hoisted_14
        ])
      ], 40, _hoisted_6),
      _createVNode(ModalWindow, {
        title: "サイトプレビュー",
        modelValue: showPreview.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showPreview).value = $event)),
        size: "lg",
        "cancel-title": "閉じる"
      }, {
        footerButton: _withCtx(() => [
          _createElementVNode("a", {
            class: "btn btn-primary mx-2",
            href: previewUrl.value,
            target: "_blank",
            role: "button"
          }, "プレビュー", 8, _hoisted_19)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm",
              onClick: copyPreviewLink
            }, [
              _createVNode(IconCopy),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(previewUrl.value), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalWindow, {
        title: "サイト公開",
        modelValue: edit_display.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((edit_display).value = $event)),
        size: "lg",
        "cancel-title": "閉じる"
      }, {
        footerButton: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn mx-2", defaultValue.value.publishMode == 'private' ? 'btn-danger' : 'btn-success']),
            onClick: publishModeUpdate,
            disabled: defaultValue.value.publishMode==settings.value.publishMode && defaultValue.value.publishMode != 'publish'
          }, _toDisplayString(publishModeLabel[defaultValue.value.publishMode].buttonLabel), 11, _hoisted_25)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            (publishError.value && publishErrorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(message)(publishErrorMessage.value)), 1))
              : _createCommentVNode("", true),
            _createVNode(FormGroup, {
              label: "公開設定",
              "label-for": "publish"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("select", {
                    name: "publish",
                    id: "publish",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((defaultValue.value.publishMode) = $event))
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(publishModeLabel, (mode, item) => {
                      return _createElementVNode("option", {
                        key: item,
                        value: item
                      }, _toDisplayString(mode.label), 9, _hoisted_24)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, defaultValue.value.publishMode]
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})